import { colors } from '@lon/shared/assets';

export const mimeTypes: Record<string, string[]> = {
  zip: [
    'application/zip',
    'application/octet-stream',
    'application/x-zip-compressed',
    'multipart/x-zip',
  ],
  rar: ['application/x-rar-compressed'],
  xml: ['application/xml', 'text/xml'],
  pdf: ['application/pdf', 'text/pdf'],
};

export const colorsByColorSchema = {
  default: {
    backgroundColor: colors.secondary['50'],
    color: colors.primary['800'],
    borderColor: colors.secondary['300'],
    iconColor: colors.secondary['300'],
  },
  blue: {
    backgroundColor: colors.info['100'],
    color: colors.primary['800'],
    borderColor: colors.primary['100'],
    iconColor: colors.primary['50'],
  },
  orange: {
    backgroundColor: colors.orange['100'],
    color: colors.orange['900'],
    borderColor: colors.orange['400'],
    iconColor: colors.orange['300'],
  },
};
